import { defineComponent as _defineComponent } from 'vue'
import { Ref, computed, ref, useSlots } from 'vue';
import type { CDropdownItem } from '.';
import CButton, { type CButtonVariant } from '@/components/shared/CButton';


export default /*#__PURE__*/_defineComponent({
  __name: 'CDropdown',
  props: {
    label: null,
    items: null,
    icon: null,
    variant: { default: 'primary' },
    tooltip: null
  },
  setup(__props: any) {

const props = __props as { label: string, items: CDropdownItem[], icon?: string, variant: CButtonVariant, tooltip?: string };



useSlots();

const expanded: Ref<boolean> = ref(false);

const icon = computed(() => (expanded.value ? 'angle-up' : 'angle-down'));

const onDropdownExpanded = () => {
    expanded.value = !expanded.value;
};

const tooltipOptions = computed(() => {
    const options: Record<string, unknown> = { interactive: false };
    if (!props.tooltip?.length) {
        options.trigger = '';
    }
    return options;
});

const handleItemClick = (item: CDropdownItem) => {
    expanded.value = false;
    item.callback();
};

return { __sfc: true,props, expanded, icon, onDropdownExpanded, tooltipOptions, handleItemClick, CButton }
}

})